interface Props {
    children: React.ReactElement[]
}
export function NoteList({ children }: Props){
    return (
        <div data-testid="note-list" className="notes">
            {children}
        </div>
    )
}